import React from 'react';
import { connect } from 'react-redux'
import { setAuthState } from '../slices'
import { Button, Field, TextInput, Icon } from '../components/ui'
import packageData from '../../package.json'
import '../theme/appShell.css'
const apiURL = process.env.REACT_APP_BACKEND
const version = packageData.version

class LoginScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            error: false,
            success: false,
            loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    };

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit(e) {
        e.preventDefault();
        if (this.state.username.trim() === '' || this.state.password.toString() === '') {
            this.setState({ error: true })
        } else {
            this.setState({ error: false, loading: true })
            fetch( apiURL + 'api/login?new=yes', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: this.state.username.trim(),
                    password: this.state.password.trim()
                })
            })
            .then(function(response) {
                if (!response.ok) {
                    throw Error(response.statusText);
                };
                return response;
            })
            .then(response => response.json())
            .then( async data => {
                this.props.setUserData( data )
                await this.props.setAuthState({field: 'webToken', value: 'JWT ' + data.token.toString()})
            })
            .catch(error => {
                console.error('Error:', error);
                this.setState({ error: true, loading: false })
            });
        };
    };

    render() {

        return (
        // [86bbumedw] P6 — "dark ops" login: fixed navy field (.gw-login), the card follows the
        // user's theme (white in light / dark in dark; dark card gets a lighter glow to separate
        // from the navy — see appShell.css). Faint blurred shield watermark lower-left.
        <div className="gw-login">
            {/* [86bbumedw] P6 — faint watermark: the REAL two-tone shield (divide) + checkmark, blurred (see appShell.css .login-watermark) */}
            <svg className="login-watermark" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5l-8-3Z" fill="var(--brand)" />
                <path d="M12 2 4 5v6c0 5 3.4 8.5 8 11V2Z" fill="#3ea0e0" />
                <path d="M9 12.5 11 15l4-5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <form onSubmit={ this.handleSubmit } className="login-card">
                <div className="brand">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5l-8-3Z" fill="var(--brand)" />
                        <path d="M12 2 4 5v6c0 5 3.4 8.5 8 11V2Z" fill="#3ea0e0" />
                        <path d="M9 12.5 11 15l4-5" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Gate</span><b>Watcher</b>
                </div>
                <p className="login-sub">Sign in to the operations console</p>

                { this.state.error &&
                    <div className="login-error" role="alert">
                        <Icon name="warning" size={16} title="Error" />
                        Username or Password Incorrect. Please retry.
                    </div>
                }

                <Field label="Username or email" htmlFor="username">
                    <TextInput
                        id="username"
                        autoComplete="username"
                        type="text"
                        name="username"
                        placeholder="username or email"
                        autoFocus={true}
                        value={ this.state.username }
                        onChange={ this.handleChange } />
                </Field>

                <Field label="Password" htmlFor="password">
                    <TextInput
                        id="password"
                        autoComplete="current-password"
                        type="password"
                        name="password"
                        value={ this.state.password }
                        onChange={ this.handleChange } />
                </Field>

                <Button
                    type="submit"
                    variant="primary"
                    loading={ this.state.loading }
                    className="login-submit">
                    Log In
                </Button>

                <div className="login-foot">Powered by Dividia Technologies · v{version}</div>
            </form>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, { setAuthState })(LoginScreen)
